import React, { useEffect, useState } from "react";
import axios from "axios";
import "./Creditos.css";
import { toast } from "react-toastify";
import * as XLSX from "xlsx";
import PageTitle from "../components/PageTitle";
import {
  FiPocket,
  FiDownload,
  FiUserCheck,
  FiAlertTriangle,
  FiRefreshCw,
  FiCheckCircle,
  FiSearch,
  FiEye,
  FiRotateCcw,
  FiSmartphone,
  FiArrowUpRight,
  FiArrowDownRight
} from "react-icons/fi";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  PieChart,
  Pie,
  Cell,
  Legend,
  CartesianGrid,
  Line,
  LineChart
} from "recharts";
import { createPortal } from "react-dom";

const API = process.env.REACT_APP_API_CREDITS;

export default function Creditos() {
  const [requests, setRequests] = useState([]);
  const [dashboard, setDashboard] = useState({});
  const [detail, setDetail] = useState(null);
  const [showDetail, setShowDetail] = useState(false);
  const [loadingDetail, setLoadingDetail] = useState(false);
  const [openHistorial, setOpenHistorial] = useState(false);
  const [showApproveModal, setShowApproveModal] = useState(false);
  const [approveTerm, setApproveTerm] = useState("");
  const [showRejectModal, setShowRejectModal] = useState(false);
  const [approveValue, setApproveValue] = useState("");
  const [rejectReason, setRejectReason] = useState("");
  const [showHistory, setShowHistory] = useState(false);
  const [historyRequests, setHistoryRequests] = useState([]);
  const [historySearch, setHistorySearch] = useState("");
  const [historyLoading, setHistoryLoading] = useState(false);
  const [, setLoading] = useState(false);

  const [
    showCreditLimitModal,
    setShowCreditLimitModal
  ] = useState(false);

  const [
    creditLimitSummary,
    setCreditLimitSummary
  ] = useState(null);

  const [
    creditLimitLoading,
    setCreditLimitLoading
  ] = useState(false);

  const [
    creditLimitError,
    setCreditLimitError
  ] = useState("");

  const [
    downloadingCreditFile,
    setDownloadingCreditFile
  ] = useState("");

  const token = localStorage.getItem("token");

  const [filters, setFilters] = useState({
    search: "",
    estado: "",
    empresa: "",
    ciudad: "",
    lineaCredito: "",
    asesor: "",
    campaignId: "",
  });

  const loadRequests = async (
    silent = false
  ) => {
    try {
      if (!silent) {
        setLoading(true);
      }

      const response =
        await axios.get(
          `${API}/requests`,
          {
            headers: {
              Authorization:
                `Bearer ${token}`
            }
          }
        );

      setRequests(
        Array.isArray(response.data)
          ? response.data
          : []
      );
    } catch (error) {
      console.error(
        "Error actualizando solicitudes:",
        error.response?.data ||
        error.message
      );

      if (!silent) {
        toast.error(
          error.response?.data?.message ||
          "No fue posible cargar las solicitudes"
        );
      }
    } finally {
      if (!silent) {
        setLoading(false);
      }
    }
  };

  const loadDashboard = async () => {
    try {
      const response =
        await axios.get(
          `${API}/dashboard`,
          {
            headers: {
              Authorization:
                `Bearer ${token}`
            }
          }
        );

      setDashboard(
        response.data || {}
      );
    } catch (error) {
      console.error(
        "Error actualizando dashboard:",
        error.response?.data ||
        error.message
      );
    }
  };

  useEffect(() => {
    loadRequests();
    loadDashboard();

    const intervaloActualizacion =
      window.setInterval(() => {
        if (
          document.visibilityState ===
          "visible"
        ) {
          loadRequests(true);
        }
      }, 5000);

    return () => {
      window.clearInterval(
        intervaloActualizacion
      );
    };
  }, [token]);

  const filteredRequests = (requests || []).filter((it) => {

    const q = filters.search.toLowerCase();

    const matchSearch =
      !q ||
      String(it.identificacion || "").toLowerCase().includes(q) ||
      String(it.nombre || "").toLowerCase().includes(q) ||
      String(it.empresa || "").toLowerCase().includes(q) ||
      String(it.ciudad || "").toLowerCase().includes(q) ||
      String(it.lineaCredito || "").toLowerCase().includes(q);

    const matchEstado =
      !filters.estado ||
      it.estado === filters.estado;

    const matchEmpresa =
      !filters.empresa ||
      it.empresa === filters.empresa;

    const matchCiudad =
      !filters.ciudad ||
      it.ciudad === filters.ciudad;

    const matchLinea =
      !filters.lineaCredito ||
      it.lineaCredito === filters.lineaCredito;

    const matchAsesor =
      !filters.asesor ||
      it.assignedTo?.nombre === filters.asesor;

    return (
      matchSearch &&
      matchEstado &&
      matchEmpresa &&
      matchCiudad &&
      matchLinea &&
      matchAsesor
    );
  });

  const pendientesActuales =
    requests.filter(
      (request) =>
        request.estado ===
        "Pendiente"
    ).length;

  const enAprobacionActuales =
    requests.filter(
      (request) =>
        request.estado ===
        "En aprobación"
    ).length;

  const empresas = [
    ...new Set(
      (requests || [])
        .map(r => r.empresa)
        .filter(Boolean)
    )
  ].sort();

  const ciudades = [
    ...new Set(
      (requests || [])
        .map(r => r.ciudad)
        .filter(Boolean)
    )
  ].sort();

  const lineasCredito = [
    ...new Set(
      (requests || [])
        .map(r => r.lineaCredito)
        .filter(Boolean)
    )
  ].sort();

  const asesores = [
    ...new Set(
      (requests || [])
        .map(r => r.assignedTo?.nombre)
        .filter(Boolean)
    )
  ].sort();

  const [page, setPage] = useState(1);

  const pageSize = 15;

  const totalPages =
    Math.ceil(
      filteredRequests.length /
      pageSize
    );

  const paginatedRequests = [...filteredRequests]
    .sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt))
    .slice(
      (page - 1) * pageSize,
      page * pageSize
    );

  const filteredHistory =
    historyRequests.filter((r) => {

      const txt =
        historySearch.toLowerCase();

      return (
        !txt ||
        r.nombre?.toLowerCase().includes(txt) ||
        r.identificacion?.includes(txt) ||
        r.campaignNombre?.toLowerCase().includes(txt)
      );

    });

  const [historyPage, setHistoryPage] =
    useState(1);

  const historyPageSize = 10;

  const historyTotalPages =
    Math.ceil(
      filteredHistory.length /
      historyPageSize
    );

  const paginatedHistory =
    filteredHistory.slice(
      (historyPage - 1) * historyPageSize,
      historyPage * historyPageSize
    );

  const openHistoryDetail = async (id) => {

    try {

      const { data } =
        await axios.get(
          `${API}/history/${id}`
        );

      setDetail(data);

      setShowDetail(true);

    } catch (error) {

      console.error(error);

    }

  };

  const handleTake = async (id) => {

    try {

      await axios.post(`${API}/requests/${id}/take`, {
        userId
      });

      await Promise.all([
        loadRequests(true),
        loadDashboard()
      ]);

      const { data } = await axios.get(
        `${API}/requests/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setDetail(data);

      setShowDetail(true);

      toast.success("Solicitud tomada correctamente");

    } catch (error) {


      console.error(error);

      toast.error(
        error?.response?.data?.message ||
        "Error tomando solicitud"
      );

    }
  };

  const handleApprove =
    async (request) => {
      if (
        !approveValue ||
        Number(approveValue) <= 0 ||
        !approveTerm ||
        Number(approveTerm) <= 0
      ) {
        return;
      }

      try {
        await axios.post(
          `${API}/requests/${request._id}/approve`,
          {
            valorAprobado:
              Number(
                approveValue
              ),

            plazoAprobado:
              Number(
                approveTerm
              ),

            userId
          },
          {
            headers: {
              Authorization:
                `Bearer ${token}`
            }
          }
        );

        setShowApproveModal(
          false
        );

        setShowDetail(false);
        setDetail(null);
        setApproveValue("");
        setApproveTerm("");

        await Promise.all([
          loadRequests(true),
          loadDashboard()
        ]);

        toast.success(
          "Solicitud aprobada y archivada correctamente"
        );
      } catch (error) {
        console.error(
          error
        );

        toast.error(
          error?.response?.data
            ?.message ||
          "No fue posible aprobar la solicitud"
        );
      }
    };


  const handleReject =
    async (request) => {
      if (
        !rejectReason.trim()
      ) {
        return;
      }

      try {
        await axios.post(
          `${API}/requests/${request._id}/reject`,
          {
            motivoRechazo:
              rejectReason.trim(),

            userId
          },
          {
            headers: {
              Authorization:
                `Bearer ${token}`
            }
          }
        );

        setShowRejectModal(
          false
        );

        setShowDetail(false);
        setDetail(null);
        setRejectReason("");

        await Promise.all([
          loadRequests(true),
          loadDashboard()
        ]);

        toast.success(
          "Solicitud rechazada y archivada correctamente"
        );
      } catch (error) {
        console.error(
          error
        );

        toast.error(
          error?.response?.data
            ?.message ||
          "No fue posible rechazar la solicitud"
        );
      }
    };

  const openDetail = async (id) => {

    try {

      setLoadingDetail(true);

      const { data } = await axios.get(
        `${API}/requests/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setDetail(data);

      // NO CERRAR HISTÓRICO
      setShowDetail(true);

    } catch (error) {

      console.error(error);

    } finally {

      setLoadingDetail(false);

    }

  };

  const user = JSON.parse(
    localStorage.getItem("user") ||
    sessionStorage.getItem("user")
  );

  console.log("USER COMPLETO:", user);

  const userId =
    user?._id ||
    user?.id;

  console.log("USER ID:", userId);

  const loadHistory = async () => {
    try {
      setHistoryLoading(true);
      setHistoryPage(1);

      const { data } =
        await axios.get(
          `${API}/history`,
          {
            headers: {
              Authorization:
                `Bearer ${token}`
            }
          }
        );

      setHistoryRequests(
        Array.isArray(data)
          ? data
          : []
      );

      return true;
    } catch (error) {
      console.error(
        "Error cargando histórico:",
        error.response?.data ||
        error.message
      );

      toast.error(
        error.response?.data?.message ||
        "No fue posible cargar el histórico"
      );

      setHistoryRequests([]);

      return false;
    } finally {
      setHistoryLoading(false);
    }
  };

  const exportRequestsExcel = () => {

    if (!filteredRequests.length) {
      toast.warning("No hay datos para exportar");
      return;
    }

    const data = filteredRequests.map((it) => ({

      "ID Solicitud": it._id,

      "ID Campaña": it.campaignId?._id || it.campaignId || "",

      "Campaña":
        it.campaignId?.nombre || "",

      "ID Cupo": it.quotaId?._id || it.quotaId || "",

      Fechacreación:
        it.createdAt
          ? new Date(it.createdAt)
            .toLocaleString("es-CO")
          : "",

      "Última actualización":
        it.updatedAt
          ? new Date(it.updatedAt)
            .toLocaleString("es-CO")
          : "",

      Identificación:
        it.identificacion || "",

      Nombre:
        it.nombre || "",

      Celular:
        it.celular || "",

      Contrato:
        it.contrato || "",

      Empresa:
        it.empresa || "",

      Ciudad:
        it.ciudad || "",

      "Línea crédito":
        it.lineaCredito || "",

      "Valor solicitado":
        it.valorSolicitado || 0,

      "Plazo meses":
        it.plazoMeses || "",

      Estado:
        it.estado || "",

      "Asesor asignado":
        it.assignedTo?.nombre || "",

      "ID Asesor":
        it.assignedTo?._id || "",

      "Fecha asignación":
        it.assignedAt
          ? new Date(it.assignedAt)
            .toLocaleString("es-CO")
          : "",

      "Valor aprobado":
        it.valorAprobado || 0,

      "Plazo aprobado":
        it.plazoAprobado || "",

      "Motivo rechazo":
        it.motivoRechazo || "",

      Observaciones:
        it.observaciones || "",

      Historial:
        it.historial?.map(h =>
          `${new Date(h.fecha)
            .toLocaleString("es-CO")}
          | Usuario: ${h.usuario}
          | Acción: ${h.accion}
          | ${h.observacion || ""}`

        ).join("\n\n") || ""

    }));

    const worksheet =
      XLSX.utils.json_to_sheet(data);

    const workbook =
      XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(
      workbook,
      worksheet,
      "Solicitudes"
    );

    XLSX.writeFile(
      workbook,
      `Solicitudes_creditos_${Date.now()}.xlsx`
    );

  };

  const exportHistoryExcel = () => {

    if (!historyRequests.length) {
      toast.warning("No hay histórico para exportar");
      return;
    }

    const data = historyRequests.map((it) => ({
      "ID Histórico":
        it._id,

      "ID Campaña":
        it.campaignId || "",

      Campaña:
        it.campaignNombre || "",

      "Fecha cierre":
        it.fechaCierre
          ? new Date(it.fechaCierre)
            .toLocaleString("es-CO")
          : "",

      "Fecha solicitud":
        it.createdAt
          ? new Date(it.createdAt)
            .toLocaleString("es-CO")
          : "",

      "Última actualización":
        it.updatedAt
          ? new Date(it.updatedAt)
            .toLocaleString("es-CO")
          : "",

      "ID Cupo":
        it.quotaId || "",

      Identificación:
        it.identificacion || "",

      Nombre:
        it.nombre || "",

      Celular:
        it.celular || "",

      Contrato:
        it.contrato || "",

      Empresa:
        it.empresa || "",

      Ciudad:
        it.ciudad || "",

      "Línea crédito":
        it.lineaCredito || "",

      "Valor solicitado":
        it.valorSolicitado || 0,

      "Plazo meses":
        it.plazoMeses || "",

      Estado:
        it.estado || "",

      "ID Asesor":
        it.assignedTo || "",

      "Fecha asignación":
        it.assignedAt
          ? new Date(it.assignedAt)
            .toLocaleString("es-CO")
          : "",

      "Valor aprobado":
        it.valorAprobado || 0,

      "Plazo aprobado":
        it.plazoAprobado || "",

      "Motivo rechazo":
        it.motivoRechazo || "",

      Observaciones:
        it.observaciones || "",

      Historial:

        it.historial?.map(h =>

          `${new Date(h.fecha)
            .toLocaleString("es-CO")}
          | Usuario: ${h.usuario}
          | Acción: ${h.accion}
          | ${h.observacion || ""}`

        ).join("\n\n") || ""

    }));

    const worksheet =
      XLSX.utils.json_to_sheet(data);

    const workbook =
      XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(
      workbook,
      worksheet,
      "Historico"
    );

    XLSX.writeFile(
      workbook,
      `Historico_creditos_${Date.now()}.xlsx`
    );

  };

  const gestionPorAsesor = (dashboard?.gestionPorAsesor || []).map(item => ({
    ...item,
    asesor: item.asesor?.split(" ")[0] || "-"
  }));

  const openCreditLimitModal = async () => {
    setShowCreditLimitModal(true);
    setCreditLimitError("");

    if (creditLimitSummary) {
      return;
    }

    await loadCreditLimitSummary();
  };

  const loadCreditLimitSummary =
    async () => {
      try {
        setCreditLimitLoading(true);
        setCreditLimitError("");

        const response =
          await axios.get(
            `${API}/limits/summary`,
            {
              headers: {
                Authorization:
                  `Bearer ${token}`
              }
            }
          );

        setCreditLimitSummary(
          response.data
        );
      } catch (error) {
        console.error(
          "Error consultando cupos:",
          error
        );

        console.error(
          "Respuesta del backend:",
          error.response?.data
        );

        const message =
          error.response?.data
            ?.message ||
          error.response?.data
            ?.error ||
          error.message ||
          "No fue posible consultar la información de cupos.";

        setCreditLimitError(
          message
        );

        toast.error(message);
      } finally {
        setCreditLimitLoading(
          false
        );
      }
    };

  const downloadCreditLimitExcel = async (
    type
  ) => {
    try {
      setDownloadingCreditFile(type);
      setCreditLimitError("");

      const isAssociates =
        type === "associates";

      const endpoint = isAssociates
        ? `${API}/limits/associates/excel`
        : `${API}/limits/non-associates/excel`;

      console.log(
        "Descargando archivo desde:",
        endpoint
      );

      const response = await axios.get(
        endpoint,
        {
          responseType: "blob",
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );

      const responseType =
        response.headers["content-type"];

      if (
        responseType &&
        responseType.includes(
          "application/json"
        )
      ) {
        const jsonText =
          await response.data.text();

        const jsonData =
          JSON.parse(jsonText);

        throw new Error(
          jsonData.message ||
          jsonData.error ||
          "El servidor no devolvió un archivo Excel."
        );
      }

      const contentDisposition =
        response.headers[
        "content-disposition"
        ];

      let fileName = isAssociates
        ? "Cupos_Credito_Asociados.xlsx"
        : "Cupos_Credito_No_Asociados.xlsx";

      if (contentDisposition) {
        const utf8FileNameMatch =
          contentDisposition.match(
            /filename\*=UTF-8''([^;]+)/i
          );

        const normalFileNameMatch =
          contentDisposition.match(
            /filename="?([^";]+)"?/i
          );

        if (
          utf8FileNameMatch &&
          utf8FileNameMatch[1]
        ) {
          fileName = decodeURIComponent(
            utf8FileNameMatch[1]
          );
        } else if (
          normalFileNameMatch &&
          normalFileNameMatch[1]
        ) {
          fileName =
            normalFileNameMatch[1].trim();
        }
      }

      const blob = new Blob(
        [response.data],
        {
          type:
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        }
      );

      const downloadUrl =
        window.URL.createObjectURL(blob);

      const downloadLink =
        document.createElement("a");

      downloadLink.href = downloadUrl;
      downloadLink.download = fileName;

      document.body.appendChild(
        downloadLink
      );

      downloadLink.click();
      downloadLink.remove();

      window.URL.revokeObjectURL(
        downloadUrl
      );

      toast.success(
        "Archivo Excel generado correctamente"
      );
    } catch (error) {
      console.error(
        "Error descargando el archivo:",
        error
      );

      let errorMessage =
        error.message ||
        "No fue posible descargar el archivo.";

      if (
        error.response?.data instanceof Blob
      ) {
        try {
          const errorText =
            await error.response.data.text();

          const errorData =
            JSON.parse(errorText);

          errorMessage =
            errorData.message ||
            errorData.error ||
            errorMessage;
        } catch (blobError) {
          console.error(
            "No fue posible leer el error del backend:",
            blobError
          );
        }
      } else if (
        error.response?.data
      ) {
        errorMessage =
          error.response.data.message ||
          error.response.data.error ||
          errorMessage;
      }

      setCreditLimitError(
        errorMessage
      );

      toast.error(errorMessage);
    } finally {
      setDownloadingCreditFile("");
    }
  };

  const formatCreditCurrency = (value) =>
    new Intl.NumberFormat("es-CO", {
      style: "currency",
      currency: "COP",
      maximumFractionDigits: 0
    }).format(Number(value) || 0);

  const capitalizeFirst = (
    value
  ) => {
    const text =
      String(value || "")
        .trim()
        .toLowerCase();

    if (!text) {
      return "";
    }

    return (
      text.charAt(0)
        .toUpperCase() +
      text.slice(1)
    );
  };

  const formatDashboardCurrency = (
    value
  ) =>
    `$${Number(
      value || 0
    ).toLocaleString(
      "es-CO",
      {
        maximumFractionDigits: 0
      }
    )}`;

  const getVariationData = (
    value
  ) => {
    const variation =
      Number(value || 0);

    return {
      value:
        Math.abs(
          variation
        ),

      positive:
        variation >= 0
    };
  };

  const renderVariation = (
    value
  ) => {
    const variation =
      getVariationData(value);

    return (
      <div
        className={
          variation.positive
            ? "inv-kpi-trend positive"
            : "inv-kpi-trend negative"
        }
      >
        {variation.positive ? (
          <FiArrowUpRight
            size={15}
          />
        ) : (
          <FiArrowDownRight
            size={15}
          />
        )}

        <span>
          {variation.value
            .toLocaleString(
              "es-CO",
              {
                maximumFractionDigits: 1
              }
            )}
          %
        </span>

        <small>
          vs. mes anterior
        </small>
      </div>
    );
  };

  const currentMonthName =
    capitalizeFirst(
      (dashboard?.periods?.currentMonth || "")
        .split(" de ")[0]
    );

  const previousMonthName =
    capitalizeFirst(
      (dashboard?.periods?.previousMonth || "")
        .split(" de ")[0]
    );

  return (

    <>

      <PageTitle title="Créditos" />

      <div className="inv-root">
        <header className="inv-header">

          <h2 className="inv-title">
            | Créditos
          </h2>

          <div className="inv-actions">

            <button
              className="cre-btn-secondary"
              onClick={exportRequestsExcel}
            >
              <FiDownload size={15} />
              Exportar
            </button>

            <button
              type="button"
              className="inv-btn-primary"
              disabled={historyLoading}
              onClick={async () => {
                setShowHistory(true);
                await loadHistory();
              }}
            >
              <FiRotateCcw
                size={15}
                className={
                  historyLoading
                    ? "cre-spin"
                    : ""
                }
              />

              {historyLoading
                ? "Cargando historial..."
                : "Historial"}
            </button>

            <button
              className="inv-btn-primary"
              onClick={openCreditLimitModal}

            >
              <FiPocket size={15} />
              Gestión de cupos
            </button>

            <button
              className="inv-btn-primary"
              onClick={() =>
                window.open(
                  "/solicitudes",
                  "_blank"
                )
              }
            >
              <FiSmartphone size={15} />
              Portal de créditos
            </button>

          </div>

        </header>

        <div className="inv-kpi-grid">
          <div className="inv-kpi-card">
            <span>
              Pendientes
            </span>

            <strong>
              {pendientesActuales
                .toLocaleString("es-CO")}
            </strong>

            <small className="inv-kpi-helper">
              A la espera de ser tomadas
            </small>
          </div>

          <div className="inv-kpi-card">
            <span>
              En aprobación
            </span>

            <strong>
              {enAprobacionActuales
                .toLocaleString("es-CO")}
            </strong>

            <small className="inv-kpi-helper">
              En gestión por un asesor
            </small>
          </div>

          <div className="inv-kpi-card">
            <span>
              Aprobadas en{" "}
              <span className="inv-month-name">
                {currentMonthName}
              </span>
            </span>

            <strong>
              {Number(
                dashboard.aprobadas ||
                0
              ).toLocaleString(
                "es-CO"
              )}
            </strong>

            {renderVariation(
              dashboard
                ?.comparisons
                ?.aprobadas
            )}
          </div>

          <div className="inv-kpi-card">
            <span>
              Rechazadas en{" "}
              <span className="inv-month-name">
                {currentMonthName}
              </span>
            </span>

            <strong>
              {Number(
                dashboard.rechazadas ||
                0
              ).toLocaleString(
                "es-CO"
              )}
            </strong>

            {renderVariation(
              dashboard
                ?.comparisons
                ?.rechazadas
            )}
          </div>

          <div className="inv-kpi-card">
            <span>
              Total aprobado en{" "}
              <span className="inv-month-name">
                {currentMonthName}
              </span>
            </span>

            <strong className="inv-kpi-money">
              {formatDashboardCurrency(
                dashboard
                  .montoAprobado
              )}
            </strong>

            {renderVariation(
              dashboard
                ?.comparisons
                ?.montoAprobado
            )}
          </div>

          <div className="inv-kpi-card inv-kpi-previous">
            <span>
              Resultados de{" "}
              <span className="inv-month-name">
                {previousMonthName}
              </span>
            </span>

            <strong className="inv-kpi-combined">
              <span className="inv-kpi-total">
                {Number(
                  dashboard?.previousMonthResults?.total || 0
                ).toLocaleString("es-CO")}
              </span>

              <i>|</i>

              <span className="inv-kpi-amount">
                {formatDashboardCurrency(
                  dashboard?.previousMonthResults?.approvedAmount
                )}
              </span>
            </strong>

            <small className="inv-kpi-helper">
              Total aprobado
            </small>
          </div>
        </div>

        <div className="dash-analytics-grid">

          {/* KPI 1: Gestión por asesor */}
          <div className="dash-chart-card">
            <div className="dash-chart-header">
              <h3>
                Gestión por asesor
              </h3>

              <p>
                Solicitudes gestionadas en{" "}
                {currentMonthName}
              </p>
            </div>

            <ResponsiveContainer
              width="100%"
              height={300}
            >
              <BarChart
                data={
                  gestionPorAsesor
                }
                margin={{
                  top: 15,
                  right: 15,
                  left: 0,
                  bottom: 10
                }}
              >
                <CartesianGrid
                  strokeDasharray="3 3"
                  stroke="#ececec"
                />

                <XAxis
                  dataKey="asesor"
                  stroke="#7a7a7a"
                  tick={{
                    fontSize: 13
                  }}
                />

                <YAxis
                  allowDecimals={false}
                  stroke="#7a7a7a"
                />

                <Tooltip
                  formatter={(
                    value,
                    name
                  ) => [
                      Number(
                        value || 0
                      ).toLocaleString(
                        "es-CO"
                      ),
                      name
                    ]}
                  contentStyle={{
                    borderRadius: "12px",
                    border:
                      "1px solid #d9d9d9",
                    background:
                      "#ffffff"
                  }}
                />

                <Legend />

                <Bar
                  dataKey="totalSolicitudes"
                  name="Total gestionadas"
                  fill="#252525"
                  radius={[7, 7, 0, 0]}
                />

                <Bar
                  dataKey="aprobadas"
                  name="Aprobadas"
                  fill="#686868"
                  radius={[7, 7, 0, 0]}
                />

                <Bar
                  dataKey="rechazadas"
                  name="Rechazadas"
                  fill="#b7b7b7"
                  radius={[7, 7, 0, 0]}
                />
              </BarChart>
            </ResponsiveContainer>
          </div>

          {/* KPI 2: Gestión por línea de crédito */}
          <div className="dash-chart-card">
            <div className="dash-chart-header">
              <h3>
                Gestión por línea de crédito
              </h3>

              <p>
                Montos solicitados y aprobados en{" "}
                {currentMonthName}
              </p>
            </div>

            <ResponsiveContainer
              width="100%"
              height={320}
            >
              <LineChart
                data={
                  dashboard
                    ?.gestionPorLineaCredito ||
                  []
                }
                margin={{
                  top: 15,
                  right: 20,
                  left: 20,
                  bottom: 10
                }}
              >
                <CartesianGrid
                  strokeDasharray="3 3"
                  stroke="#e5e5e5"
                />

                <XAxis
                  dataKey="lineaCredito"
                  stroke="#7a7a7a"
                  tick={{
                    fontSize: 13
                  }}
                />

                <YAxis
                  stroke="#7a7a7a"
                  width={65}
                  tickFormatter={(
                    value
                  ) =>
                    `${(
                      Number(value) /
                      1000000
                    ).toFixed(0)}M`
                  }
                />

                <Tooltip
                  formatter={(
                    value,
                    name
                  ) => [
                      formatDashboardCurrency(
                        value
                      ),
                      name
                    ]}
                  contentStyle={{
                    borderRadius: "12px",
                    border:
                      "1px solid #d9d9d9",
                    background:
                      "#ffffff"
                  }}
                />

                <Legend />

                <Line
                  type="monotone"
                  dataKey="montoSolicitado"
                  name="Solicitado"
                  stroke="#2b2b2b"
                  strokeWidth={3}
                  dot={{
                    fill: "#2b2b2b",
                    r: 5
                  }}
                  activeDot={{
                    r: 7
                  }}
                />

                <Line
                  type="monotone"
                  dataKey="montoAprobado"
                  name="Aprobado"
                  stroke="#9e9e9e"
                  strokeWidth={3}
                  dot={{
                    fill: "#9e9e9e",
                    r: 5
                  }}
                  activeDot={{
                    r: 7
                  }}
                />
              </LineChart>
            </ResponsiveContainer>
          </div>

          {/* KPI 3: Aprobadas vs rechazadas */}
          <div className="dash-chart-card">
            <div className="dash-chart-header">
              <h3>
                Aprobadas vs rechazadas
              </h3>

              <p>
                Resultados finalizados en{" "}
                {currentMonthName}
              </p>
            </div>

            <ResponsiveContainer
              width="100%"
              height={300}
            >
              <PieChart>
                <Pie
                  data={
                    dashboard
                      ?.aprobadosVsRechazados ||
                    []
                  }
                  dataKey="total"
                  nameKey="estado"
                  cx="50%"
                  cy="50%"
                  innerRadius={65}
                  outerRadius={98}
                  paddingAngle={4}
                  label={({
                    estado,
                    total
                  }) =>
                    `${estado}: ${Number(
                      total || 0
                    ).toLocaleString(
                      "es-CO"
                    )}`
                  }
                >
                  {(
                    dashboard
                      ?.aprobadosVsRechazados ||
                    []
                  ).map(
                    (
                      entry,
                      index
                    ) => (
                      <Cell
                        key={
                          `credit-result-${index}`
                        }
                        fill={
                          entry.estado ===
                            "Aprobada"
                            ? "#2f2f2f"
                            : "#b8b8b8"
                        }
                      />
                    )
                  )}
                </Pie>

                <Tooltip
                  formatter={(
                    value
                  ) =>
                    Number(
                      value || 0
                    ).toLocaleString(
                      "es-CO"
                    )
                  }
                />

                <Legend />
              </PieChart>
            </ResponsiveContainer>
          </div>

        </div>

        <div className="inv-filters">
          <div className="inv-row">

            {/* 🔍 BUSCADOR */}
            <div className="afil-field">
              <FiSearch />
              <input
                placeholder="Buscar..."
                value={filters.search}
                onChange={(e) =>
                  setFilters({
                    ...filters,
                    search: e.target.value
                  })
                }
              />
            </div>

            {/* ✅ ESTADO */}
            <select
              className="inv-select"
              value={filters.estado}
              onChange={(e) =>
                setFilters({
                  ...filters,
                  estado: e.target.value
                })
              }
            >
              <option value="">Todos los estados</option>
              <option>Pendiente</option>
              <option>En aprobación</option>
              <option>Aprobada</option>
              <option>Rechazada</option>
            </select>

            {/* 🏢 EMPRESA */}
            <select
              className="inv-select"
              value={filters.empresa}
              onChange={(e) =>
                setFilters({
                  ...filters,
                  empresa: e.target.value
                })
              }
            >
              <option value="">Todas las empresas</option>

              {empresas.map((empresa) => (
                <option key={empresa} value={empresa}>
                  {empresa}
                </option>
              ))}
            </select>

            {/* 📍 CIUDAD */}
            <select
              className="inv-select"
              value={filters.ciudad}
              onChange={(e) =>
                setFilters({
                  ...filters,
                  ciudad: e.target.value
                })
              }
            >
              <option value="">Todas las ciudades</option>

              {ciudades.map((ciudad) => (
                <option key={ciudad} value={ciudad}>
                  {ciudad}
                </option>
              ))}
            </select>

            {/* 💳 LÍNEA DE CRÉDITO */}
            <select
              className="inv-select"
              value={filters.lineaCredito}
              onChange={(e) =>
                setFilters({
                  ...filters,
                  lineaCredito: e.target.value
                })
              }
            >
              <option value="">Todas las líneas</option>

              {lineasCredito.map((linea) => (
                <option key={linea} value={linea}>
                  {linea}
                </option>
              ))}
            </select>

            {/* 👤 ASESOR */}
            <select
              className="inv-select"
              value={filters.asesor}
              onChange={(e) =>
                setFilters({
                  ...filters,
                  asesor: e.target.value
                })
              }
            >
              <option value="">Todos los asesores</option>

              {asesores.map((asesor) => (
                <option key={asesor} value={asesor}>
                  {asesor}
                </option>
              ))}
            </select>

            {/* 🔄 RESET */}
            <button
              className="cre-btn-ghost"
              onClick={() => {
                setFilters({
                  search: "",
                  estado: "",
                  empresa: "",
                  ciudad: "",
                  lineaCredito: "",
                  asesor: ""
                });
                setPage(1);
              }}
            >
              Restablecer
            </button>

          </div>
        </div>

        <div className="inv-table">

          <table>

            <thead>
              <tr>
                <th>Fecha</th>
                <th>Identificación</th>
                <th>Nombre</th>
                <th>Empresa</th>
                <th>Ciudad</th>
                <th>Línea de crédito</th>
                <th>Valor solicitud</th>
                <th>Valor aprobado</th>
                <th>Estado</th>
                <th>Asesor</th>
                <th>Acciones</th>
              </tr>
            </thead>

            <tbody>

              {paginatedRequests.map((it) => (

                <tr key={it._id}>

                  <td>
                    {new Date(it.createdAt)
                      .toLocaleDateString("es-CO")}
                  </td>

                  <td>{it.identificacion}</td>

                  <td>{it.nombre}</td>

                  <td>
                    {it.empresa?.length > 20
                      ? `${it.empresa.substring(0, 20)}...`
                      : it.empresa}
                  </td>

                  <td>{it.ciudad}</td>

                  <td>{it.lineaCredito}</td>

                  <td>
                    ${" "}
                    {it.valorSolicitado
                      ?.toLocaleString("es-CO")}
                  </td>

                  <td>
                    {it.valorAprobado
                      ? `$ ${it.valorAprobado.toLocaleString("es-CO")}`
                      : "$ 0"}
                  </td>

                  <td>{it.estado}</td>

                  <td>
                    {it.assignedTo?.nombre || "-"}
                  </td>

                  <td className="inv-actions-row">

                    <button
                      className="inv-icon-btn"
                      title="Ver detalle"
                      onClick={() =>
                        openDetail(it._id)
                      }
                    >
                      <FiEye />
                    </button>

                    {it.estado === "Pendiente" && (
                      <button
                        className="inv-icon-btn"
                        title="Tomar solicitud"
                        onClick={() => handleTake(it._id)}
                      >
                        <FiUserCheck />
                      </button>
                    )}

                  </td>

                </tr>

              ))}

            </tbody>

          </table>

          {/* ================= PAGINACIÓN ================= */}
          <div className="cre-paginacion">
            <button
              disabled={page === 1}
              onClick={() => setPage(page - 1)}
            >
              Anterior
            </button>

            <span className="inv-pagina-info">
              Página {page} de {totalPages}
            </span>

            <button
              disabled={page === totalPages}
              onClick={() => setPage(page + 1)}
            >
              Siguiente
            </button>
          </div>
        </div>

        {showDetail && detail && (
          createPortal(
            <div
              className="crh-modal-overlay-II"
              onClick={() => setShowDetail(false)}
            >
              <div
                className="cr360-detalle-modal"
                onClick={(e) => e.stopPropagation()}
              >
                {/* HEADER */}
                <div className="cr360-detalle-header">
                  <div className="cr360-detalle-header-content">
                    <h2>Detalle Solicitud de Crédito</h2>
                    <p>
                      {detail.createdAt
                        ? `Creado el ${new Date(detail.createdAt).toLocaleString("es-CO")}`
                        : "Información de la solicitud"}
                    </p>
                  </div>

                  <button
                    className="cre-close-btn"
                    onClick={() => setShowDetail(false)}
                    title="Cerrar"
                  >
                    ✕
                  </button>
                </div>

                {/* LOADING */}
                {loadingDetail && (
                  <div className="cr360-loading-box">
                    <p>Cargando...</p>
                  </div>
                )}

                {!loadingDetail && (
                  <>
                    {/* KPIS */}
                    <div className="cr360-kpis-grid">
                      <div className="cr360-kpi">
                        <span>Estado</span>
                        <strong>{detail.estado || "-"}</strong>
                      </div>

                      <div className="cr360-kpi">
                        <span>Línea de crédito</span>
                        <strong>{detail.lineaCredito || "-"}</strong>
                      </div>

                      <div className="cr360-kpi">
                        <span>Plazo</span>
                        <strong>
                          {detail.plazoMeses
                            ? detail.plazoMeses === 1
                              ? "1 mes"
                              : `${detail.plazoMeses} meses`
                            : "-"}
                        </strong>
                      </div>

                      <div className="cr360-kpi">
                        <span>Valor solicitado</span>
                        <strong>
                          {detail.valorSolicitado != null
                            ? `$ ${Number(detail.valorSolicitado).toLocaleString("es-CO")}`
                            : "-"}
                        </strong>
                      </div>

                      <div className="cr360-kpi">
                        <span>Valor aprobado</span>
                        <strong>
                          {detail.valorAprobado != null && detail.valorAprobado > 0
                            ? `$ ${Number(detail.valorAprobado).toLocaleString("es-CO")}`
                            : "-"}
                        </strong>
                      </div>
                    </div>

                    {/* DATOS DEL SOLICITANTE */}
                    <div className="cr360-section">
                      <div className="cr360-section-title">
                        <h3>Datos del asociado</h3>
                      </div>

                      <div className="cr360-line-card">
                        <div className="cr360-line-item">
                          <span>Documento</span>
                          <strong>{detail.identificacion || "-"}</strong>
                        </div>

                        <div className="cr360-line-divider" />

                        <div className="cr360-line-item">
                          <span>Nombre</span>
                          <strong>{detail.nombre || "-"}</strong>
                        </div>

                        <div className="cr360-line-divider" />

                        <div className="cr360-line-item">
                          <span>Celular</span>
                          <strong>{detail.celular || "-"}</strong>
                        </div>

                        <div className="cr360-line-divider" />

                        <div className="cr360-line-item">
                          <span>Empresa</span>
                          <strong>{detail.empresa || "-"}</strong>
                        </div>

                        <div className="cr360-line-divider" />

                        <div className="cr360-line-item">
                          <span>Ciudad</span>
                          <strong>{detail.ciudad || "-"}</strong>
                        </div>

                        <div className="cr360-line-divider" />

                        <div className="cr360-line-item">
                          <span>Contrato</span>
                          <strong>{detail.contrato || "-"}</strong>
                        </div>
                      </div>
                    </div>

                    {/* INFORMACIÓN DEL CRÉDITO */}
                    <div className="cr360-section">
                      <div className="cr360-section-title">
                        <h3>Información del estudio</h3>
                      </div>

                      <div className="cr360-card">
                        <div className="cr360-grid">
                          <div className="cr360-field">
                            <label>Asesor</label>
                            <p>{detail.assignedTo?.nombre || "-"}</p>
                          </div>

                          <div className="cr360-field">
                            <label>Motivo rechazo</label>
                            <p>{detail.motivoRechazo || "-"}</p>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* HISTORIAL */}
                    <div className="cr360-section">
                      <div
                        className="cr360-accordion-header"
                        onClick={() => setOpenHistorial(!openHistorial)}
                      >
                        <h3>Historial</h3>

                        <span className={`cr360-accordion-icon ${openHistorial ? "open" : ""}`}>
                          ▾
                        </span>
                      </div>

                      {/* CONTENIDO */}
                      <div
                        className={`cr360-accordion-content ${openHistorial ? "open" : ""
                          }`}
                      >
                        <div className="cr360-history-wrap">

                          {(!detail.historial || detail.historial.length === 0) && (
                            <div className="cr360-history-empty">
                              <p>Sin movimientos</p>
                            </div>
                          )}

                          {detail.historial?.map((h, index) => (
                            <div key={index} className="cr360-history-item">

                              <div className="cr360-history-top">
                                <div className="cr360-history-action">
                                  {h.accion || "-"}
                                </div>

                                <div className="cr360-history-date">
                                  {h.fecha
                                    ? new Date(h.fecha).toLocaleString("es-CO")
                                    : "-"}
                                </div>
                              </div>

                              <div className="cr360-history-user">
                                {h.usuario || "-"}
                              </div>

                              <div className="cr360-history-note">
                                {h.observacion || "-"}
                              </div>

                            </div>
                          ))}

                        </div>
                      </div>
                    </div>

                    {/* ACCIONES */}
                    <div className="cr360-actions">
                      {detail.estado === "Pendiente" && (
                        <button
                          className="cre-btn-primary"
                          onClick={async () => {
                            try {
                              await axios.post(
                                `${API}/requests/${detail._id}/take`,
                                { userId }
                              );

                              await Promise.all([
                                loadRequests(true),
                                loadDashboard()
                              ]);

                              const { data } = await axios.get(
                                `${API}/requests/${detail._id}`,
                                {
                                  headers: {
                                    Authorization: `Bearer ${token}`,
                                  },
                                }
                              );

                              setDetail(data);
                            } catch (error) {
                              toast.error(error?.response?.data?.message);
                            }
                          }}
                        >
                          Tomar solicitud
                        </button>
                      )}

                      {detail.estado === "En aprobación" &&
                        String(detail.assignedTo?._id) === String(userId) && (
                          <>

                            <button
                              className="cre-btn-secondary"
                              onClick={() => {
                                setRejectReason("");
                                setShowRejectModal(true);
                              }}
                            >
                              Rechazar
                            </button>

                            <button
                              className="cre-btn-primary"
                              onClick={() => {
                                setApproveValue(
                                  detail.valorSolicitado != null
                                    ? String(detail.valorSolicitado)
                                    : ""
                                );

                                setApproveTerm(
                                  detail.plazoMeses != null
                                    ? String(detail.plazoMeses)
                                    : ""
                                );

                                setShowApproveModal(true);
                              }}
                            >
                              Aprobar
                            </button>
                          </>
                        )}
                    </div>
                  </>
                )}
              </div>
            </div>,
            document.body
          )
        )}

        {showApproveModal && detail && (
          createPortal(
            <div
              className="crh-modal-overlay-II"
              onClick={() => setShowApproveModal(false)}
            >
              <div
                className="cre-action-modal"
                onClick={(e) => e.stopPropagation()}
              >
                <div className="cre-action-header centered">
                  <h3>Aprobar Solicitud</h3>
                </div>

                <p className="cre-action-text">
                  Confirma el valor aprobado para esta solicitud.
                </p>

                <div className="cre-action-field">
                  <label>Valor aprobado</label>
                  <input
                    type="number"
                    value={approveValue}
                    onChange={(e) => setApproveValue(e.target.value)}
                    placeholder="Ej: 1500000"
                  />
                </div>

                <div className="cre-action-field">
                  <label>Plazo aprobado (meses)</label>

                  <input
                    type="number"
                    value={approveTerm}
                    onChange={(e) => setApproveTerm(e.target.value)}
                    min="1"
                  />
                </div>

                <div className="cre-action-buttons">
                  <button
                    className="cre-btn-secondary"
                    onClick={() => setShowApproveModal(false)}
                  >
                    Cancelar
                  </button>

                  <button
                    className="cre-btn-primary"
                    onClick={() => handleApprove(detail)}
                    disabled={
                      !approveValue ||
                      Number(approveValue) <= 0 ||
                      !approveTerm ||
                      Number(approveTerm) <= 0
                    }
                  >
                    Confirmar aprobación
                  </button>
                </div>
              </div>
            </div>,
            document.body
          )
        )}

        {showRejectModal && detail && (
          createPortal(
            <div
              className="crh-modal-overlay-II"
              onClick={() => setShowRejectModal(false)}
            >
              <div
                className="cre-action-modal"
                onClick={(e) => e.stopPropagation()}
              >
                <div className="cre-action-header centered">
                  <h3>Rechazar Solicitud</h3>
                </div>

                <p className="cre-action-text">
                  Selecciona y confirma el motivo del rechazo.
                </p>

                <div className="cre-action-field">
                  <label>Motivo de rechazo</label>

                  <select
                    value={rejectReason}
                    onChange={(e) => setRejectReason(e.target.value)}
                    className="cre-select"
                  >
                    <option value="">
                      Seleccione una opción...
                    </option>

                    <option value="Rechazado.">
                      Bloqueado
                    </option>

                    <option value="Rechazado.">
                      En bajas
                    </option>

                    <option value="Rechazado.">
                      No asociado
                    </option>

                    <option value="Rechazado.">
                      Sin contrato
                    </option>

                    <option value="Sin cupo disponible.">
                      Sin cupo
                    </option>

                    <option value="Solicitud duplicada.">
                      Solicitud duplicada
                    </option>
                  </select>
                </div>

                <div className="cre-action-buttons">
                  <button
                    className="cre-btn-secondary"
                    onClick={() => setShowRejectModal(false)}
                  >
                    Cancelar
                  </button>

                  <button
                    className="cre-btn-primary"
                    onClick={() => handleReject(detail)}
                    disabled={!rejectReason}
                  >
                    Confirmar rechazo
                  </button>
                </div>
              </div>
            </div>,
            document.body
          )
        )}

        {showHistory && (
          createPortal(
            <div className="crh-modal-overlay-II">

              <div className="crh-modal">

                <div className="crh-header">

                  <div className="crh-title">

                    <h2>
                      Histórico de Solicitudes
                    </h2>

                    <span>
                      {historyRequests.length.toLocaleString("es-CO")} registros archivados
                    </span>

                  </div>

                  <div className="crh-actions">

                    <button
                      type="button"
                      className="cre-btn-primary"
                      onClick={exportHistoryExcel}
                      disabled={
                        historyLoading ||
                        historyRequests.length === 0
                      }
                    >

                      <FiDownload />
                      Exportar
                    </button>

                  </div>

                </div>

                <div className="crh-toolbar">

                  <div className="crh-search">

                    <FiSearch />

                    <input
                      placeholder="Buscar por nombre o identificación..."
                      value={historySearch}
                      onChange={(e) =>
                        setHistorySearch(
                          e.target.value
                        )
                      }
                    />

                  </div>

                </div>

                <div className="crh-table-wrap">
                  {historyLoading ? (
                    <div className="crh-history-loading">
                      <FiRefreshCw
                        size={28}
                        className="cre-spin"
                      />

                      <strong>
                        Cargando historial...
                      </strong>

                      <span>
                        Consultando las solicitudes archivadas.
                      </span>
                    </div>
                  ) : paginatedHistory.length === 0 ? (
                    <div className="crh-history-loading">
                      <FiAlertTriangle size={28} />

                      <strong>
                        No hay registros
                      </strong>

                      <span>
                        No se encontraron solicitudes en el historial.
                      </span>
                    </div>
                  ) : (
                    <>
                      <table className="crh-table">
                        <thead>
                          <tr>
                            <th>Fecha solicitud</th>
                            <th>Identificación</th>
                            <th>Nombre</th>
                            <th>Empresa</th>
                            <th>Ciudad</th>
                            <th>Valor aprobado</th>
                            <th>Estado</th>
                            <th>Acciones</th>
                          </tr>
                        </thead>

                        <tbody>
                          {paginatedHistory.map((it) => (
                            <tr key={it._id}>
                              <td>
                                {it.createdAt
                                  ? new Date(
                                    it.createdAt
                                  ).toLocaleDateString(
                                    "es-CO"
                                  )
                                  : "-"}
                              </td>

                              <td>
                                {it.identificacion || "-"}
                              </td>

                              <td>
                                {it.nombre || "-"}
                              </td>

                              <td>
                                {it.empresa || "-"}
                              </td>

                              <td>
                                {it.ciudad || "-"}
                              </td>

                              <td>
                                $
                                {Number(
                                  it.valorAprobado || 0
                                ).toLocaleString("es-CO")}
                              </td>

                              <td>
                                {it.estado || "-"}
                              </td>

                              <td>
                                <button
                                  type="button"
                                  className="inv-icon-btn"
                                  title="Ver detalle"
                                  onClick={() =>
                                    openHistoryDetail(
                                      it._id
                                    )
                                  }
                                >
                                  <FiEye />
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>

                      {historyTotalPages > 1 && (
                        <div className="cre-paginacion">
                          <button
                            type="button"
                            disabled={
                              historyPage === 1
                            }
                            onClick={() =>
                              setHistoryPage(
                                (paginaActual) =>
                                  paginaActual - 1
                              )
                            }
                          >
                            Anterior
                          </button>

                          <span>
                            Página {historyPage} de{" "}
                            {historyTotalPages}
                          </span>

                          <button
                            type="button"
                            disabled={
                              historyPage >=
                              historyTotalPages
                            }
                            onClick={() =>
                              setHistoryPage(
                                (paginaActual) =>
                                  paginaActual + 1
                              )
                            }
                          >
                            Siguiente
                          </button>
                        </div>
                      )}
                    </>
                  )}
                </div>

                <div className="cre-history-footer">

                  <button
                    className="cre-btn-secondary"
                    onClick={() =>
                      setShowHistory(false)
                    }
                  >
                    Cerrar
                  </button>

                </div>

              </div>

            </div>,
            document.body
          )

        )}

        {showCreditLimitModal && (
          createPortal(
            <div
              className="crh-modal-overlay-II"
              onMouseDown={(event) => {
                if (
                  event.target === event.currentTarget &&
                  !downloadingCreditFile
                ) {
                  setShowCreditLimitModal(false);
                }
              }}
            >
              <div
                className="credit-limit-modal"
                role="dialog"
                aria-modal="true"
                aria-labelledby="credit-limit-modal-title"
              >
                <div className="credit-limit-modal-header">
                  <div className="credit-limit-modal-title-wrapper">
                    <div>
                      <h2 id="credit-limit-modal-title">
                        Gestión de Cupos
                      </h2>

                      <p>
                        Consulta y descarga los cupos de crédito
                        calculados para asociados y no asociados
                      </p>
                    </div>
                  </div>

                  <button
                    type="button"
                    className="credit-limit-modal-close"
                    onClick={() =>
                      setShowCreditLimitModal(false)
                    }
                    disabled={Boolean(
                      downloadingCreditFile
                    )}
                    aria-label="Cerrar"
                  >
                    ✕
                  </button>
                </div>

                <div className="credit-limit-modal-body">
                  {creditLimitLoading ? (
                    <div className="credit-limit-loading">
                      <h3>
                        Calculando Cupos de Crédito
                      </h3>

                      <p>
                        Estamos cruzando asociados, empleados
                        activos, ahorros, créditos vigentes y
                        tipos de contrato.
                      </p>

                      <div className="credit-limit-progress">
                        <div className="credit-limit-progress-bar" />
                      </div>
                    </div>
                  ) : creditLimitError &&
                    !creditLimitSummary ? (
                    <div className="credit-limit-error-state">
                      <FiAlertTriangle size={32} />

                      <h3>
                        No pudimos consultar los cupos
                      </h3>

                      <p>{creditLimitError}</p>

                      <button
                        type="button"
                        className="credit-limit-retry-btn"
                        onClick={loadCreditLimitSummary}
                      >
                        <FiRefreshCw size={16} />
                        Intentar nuevamente
                      </button>
                    </div>
                  ) : creditLimitSummary ? (
                    <>
                      <div className="credit-limit-groups">
                        <section className="credit-limit-group">
                          <div className="credit-limit-group-header">
                            <div className="credit-limit-group-heading">
                              <div className="credit-limit-group-icon associates">
                                <FiArrowDownRight size={20} />
                              </div>

                              <div>
                                <h3>
                                  Cupos de asociados
                                </h3>

                                <p>
                                  Asociados activos en el Fondo de Empleados
                                </p>
                              </div>
                            </div>

                            <span className="credit-limit-status">
                              <FiCheckCircle size={14} />
                              Disponible
                            </span>
                          </div>

                          <div className="credit-limit-stats-grid">
                            <div className="credit-limit-stat">
                              <span>
                                Coincidencias
                              </span>

                              <strong>
                                {creditLimitSummary
                                  .associates
                                  .evaluatedRecords
                                  .toLocaleString(
                                    "es-CO"
                                  )}
                              </strong>
                            </div>

                            <div className="credit-limit-stat">
                              <span>
                                Calculados
                              </span>

                              <strong>
                                {creditLimitSummary
                                  .associates
                                  .validRecords
                                  .toLocaleString(
                                    "es-CO"
                                  )}
                              </strong>
                            </div>

                            <div className="credit-limit-stat">
                              <span>
                                Contrato Fijo
                              </span>

                              <strong>
                                {creditLimitSummary
                                  .associates
                                  .coRecords
                                  .toLocaleString(
                                    "es-CO"
                                  )}
                              </strong>
                            </div>

                            <div className="credit-limit-stat">
                              <span>
                                Contrato Indefinido
                              </span>

                              <strong>
                                {creditLimitSummary
                                  .associates
                                  .tiRecords
                                  .toLocaleString(
                                    "es-CO"
                                  )}
                              </strong>
                            </div>
                          </div>

                          <div className="credit-limit-group-total">
                            <span>
                              Cupo total de asociados
                            </span>

                            <strong>
                              {formatCreditCurrency(
                                creditLimitSummary
                                  .associates
                                  .totalAvailableLimit
                              )}
                            </strong>
                          </div>

                          <button
                            type="button"
                            className="credit-limit-download-btn associates"
                            onClick={() =>
                              downloadCreditLimitExcel(
                                "associates"
                              )
                            }
                            disabled={Boolean(
                              downloadingCreditFile
                            )}
                          >
                            {downloadingCreditFile ===
                              "associates" ? (
                              <>
                                Descargando...
                              </>
                            ) : (
                              <>
                                Descargar cupos
                              </>
                            )}
                          </button>
                        </section>

                        <section className="credit-limit-group">
                          <div className="credit-limit-group-header">
                            <div className="credit-limit-group-heading">
                              <div className="credit-limit-group-icon non-associates">
                                <FiArrowUpRight size={20} />
                              </div>

                              <div>
                                <h3>
                                  Cupos de no asociados
                                </h3>

                                <p>
                                  Empleados activos no afiliados al Fondo de Empleados
                                </p>
                              </div>
                            </div>

                            <span className="credit-limit-status">
                              <FiCheckCircle size={14} />
                              Disponible
                            </span>
                          </div>

                          <div className="credit-limit-stats-grid">
                            <div className="credit-limit-stat">
                              <span>
                                Identificados
                              </span>

                              <strong>
                                {creditLimitSummary
                                  .nonAssociates
                                  .evaluatedRecords
                                  .toLocaleString(
                                    "es-CO"
                                  )}
                              </strong>
                            </div>

                            <div className="credit-limit-stat">
                              <span>
                                Calculados
                              </span>

                              <strong>
                                {creditLimitSummary
                                  .nonAssociates
                                  .validRecords
                                  .toLocaleString(
                                    "es-CO"
                                  )}
                              </strong>
                            </div>

                            <div className="credit-limit-stat">
                              <span>
                                Contrato Fijo
                              </span>

                              <strong>
                                {creditLimitSummary
                                  .nonAssociates
                                  .coRecords
                                  .toLocaleString(
                                    "es-CO"
                                  )}
                              </strong>
                            </div>

                            <div className="credit-limit-stat">
                              <span>
                                Contrato Indefinido
                              </span>

                              <strong>
                                {creditLimitSummary
                                  .nonAssociates
                                  .tiRecords
                                  .toLocaleString(
                                    "es-CO"
                                  )}
                              </strong>
                            </div>
                          </div>

                          <div className="credit-limit-group-total">
                            <span>
                              Cupo total de no asociados
                            </span>

                            <strong>
                              {formatCreditCurrency(
                                creditLimitSummary
                                  .nonAssociates
                                  .totalAvailableLimit
                              )}
                            </strong>
                          </div>

                          <button
                            type="button"
                            className="credit-limit-download-btn non-associates"
                            onClick={() =>
                              downloadCreditLimitExcel(
                                "nonAssociates"
                              )
                            }
                            disabled={Boolean(
                              downloadingCreditFile
                            )}
                          >
                            {downloadingCreditFile ===
                              "nonAssociates" ? (
                              <>
                                Descargando...
                              </>
                            ) : (
                              <>
                                Descargar cupos
                              </>
                            )}
                          </button>
                        </section>
                      </div>

                      <div className="credit-limit-alerts">
                        <div className="credit-limit-alerts-header">
                          <FiAlertTriangle size={18} />

                          <div>
                            <h3>
                              Calidad de la información
                            </h3>

                            <p>
                              Registros que requieren validación
                              antes de calcular correctamente el
                              cupo.
                            </p>
                          </div>
                        </div>

                        <div className="credit-limit-alerts-grid">
                          <div className="credit-limit-alert-item">
                            <span>
                              Sin salario
                            </span>

                            <strong>
                              {(
                                creditLimitSummary
                                  .associates
                                  .warnings
                                  .withoutSalary +
                                creditLimitSummary
                                  .nonAssociates
                                  .warnings
                                  .withoutSalary
                              ).toLocaleString(
                                "es-CO"
                              )}
                            </strong>
                          </div>

                          <div className="credit-limit-alert-item">
                            <span>
                              Sin fecha de ingreso
                            </span>

                            <strong>
                              {(
                                creditLimitSummary
                                  .associates
                                  .warnings
                                  .withoutStartDate +
                                creditLimitSummary
                                  .nonAssociates
                                  .warnings
                                  .withoutStartDate
                              ).toLocaleString(
                                "es-CO"
                              )}
                            </strong>
                          </div>

                          <div className="credit-limit-alert-item">
                            <span>
                              Contrato sin clasificar
                            </span>

                            <strong>
                              {(
                                creditLimitSummary
                                  .associates
                                  .warnings
                                  .invalidContract +
                                creditLimitSummary
                                  .nonAssociates
                                  .warnings
                                  .invalidContract
                              ).toLocaleString(
                                "es-CO"
                              )}
                            </strong>
                          </div>

                          <div className="credit-limit-alert-item">
                            <span>
                              Sin correo
                            </span>

                            <strong>
                              {(
                                creditLimitSummary
                                  .associates
                                  .warnings
                                  .withoutEmail +
                                creditLimitSummary
                                  .nonAssociates
                                  .warnings
                                  .withoutEmail
                              ).toLocaleString(
                                "es-CO"
                              )}
                            </strong>
                          </div>

                          <div className="credit-limit-alert-item">
                            <span>
                              Sin celular
                            </span>

                            <strong>
                              {(
                                creditLimitSummary
                                  .associates
                                  .warnings
                                  .withoutPhone +
                                creditLimitSummary
                                  .nonAssociates
                                  .warnings
                                  .withoutPhone
                              ).toLocaleString(
                                "es-CO"
                              )}
                            </strong>
                          </div>

                          <div className="credit-limit-alert-item">
                            <span>
                              Duplicados
                            </span>

                            <strong>
                              {(
                                creditLimitSummary
                                  .associates
                                  .warnings
                                  .duplicateIdentification +
                                creditLimitSummary
                                  .nonAssociates
                                  .warnings
                                  .duplicateIdentification
                              ).toLocaleString(
                                "es-CO"
                              )}
                            </strong>
                          </div>
                        </div>
                      </div>

                      {creditLimitError && (
                        <div className="credit-limit-inline-error">
                          <FiAlertTriangle size={17} />
                          <span>
                            {creditLimitError}
                          </span>
                        </div>
                      )}
                    </>
                  ) : null}
                </div>

                <div className="credit-limit-modal-footer">
                  <button
                    type="button"
                    className="credit-limit-refresh-btn"
                    onClick={loadCreditLimitSummary}
                    disabled={
                      creditLimitLoading ||
                      Boolean(downloadingCreditFile)
                    }
                  >
                    <FiRefreshCw size={16} />
                    Actualizar información
                  </button>

                  <span>
                    Los cupos se vuelven a calcular al
                    generar cada archivo.
                  </span>
                </div>
              </div>
            </div>,
            document.body
          )
        )}

      </div>

    </>

  );

}

